import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'pe_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'pe_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'pe_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'pe_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'pe_height',
    type: 'info',
    answer: {
      name: 'pe_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'pe_weight',
    type: 'info',
    answer: {
      name: 'pe_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'How long have you experienced symptoms of premature ejaculation?',
    field: 'pe_duration',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_duration_1to3',
          value: '1-3 months'
        },
        {
          key: 'pe_duration_3to6',
          value: '3-6 months'
        },
        {
          key: 'pe_duration_6to12',
          value: '6-12 months'
        },
        {
          key: 'pe_duration_overYear',
          value: 'It has been over a year'
        }
      ]
    }
  },
  {
    label: 'How did your premature ejaculation start?',
    field: 'pe_onset',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_onset_always',
          value: 'I have dealt with it as long as I have been sexually active'
        },
        {
          key: 'pe_onset_newPartner',
          value: 'Suddenly, with a new partner'
        },
        {
          key: 'pe_onset_suddenly',
          value: 'Suddenly, but not with a new partner'
        },
        {
          key: 'pe_onset_gradually',
          value: 'Gradually, but has worsened over time'
        },
        {
          key: 'pe_onset_dontRecall',
          value: 'I do not recall how it started'
        }
      ]
    }
  },
  {
    label:
      'Which option best describes the average duration of time before you normally ejaculate?',
    field: 'pe_timeToEjaculation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_timeToEjaculation_before',
          value: 'Before vaginal or anal penetration'
        },
        {
          key: 'pe_timeToEjaculation_1min',
          value: 'Within 1 minute of vaginal or anal penetration'
        },
        {
          key: 'pe_timeToEjaculation_1to3',
          value: 'Within 1–3 minutes of vaginal or anal penetration'
        },
        {
          key: 'pe_timeToEjaculation_5to10',
          value: 'Within 5–10 minutes of vaginal or anal penetration'
        },
        {
          key: 'pe_timeToEjaculation_over10',
          value: 'More than 10 minutes after vaginal or anal penetration'
        }
      ]
    }
  },
  {
    label: 'Do you or your partner find this distressing?',
    field: 'pe_distress',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_distress_yes',
          value: 'Yes'
        },
        {
          key: 'pe_distress_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Have you ever been treated for premature ejaculation?',
    field: 'pe_previousTreatment',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_previousTreatment_topical',
          value: 'Topical anesthetic spray, gel, or wipes'
        },
        {
          key: 'pe_previousTreatment_condom',
          value: 'Condom use'
        },
        {
          key: 'pe_previousTreatment_startStop',
          value: 'Start-stop method'
        },
        {
          key: 'pe_previousTreatment_prozac',
          value: 'Prozac (Fluoxetine)'
        },
        {
          key: 'pe_previousTreatment_paxil',
          value: 'Paxil (Paroxetine)'
        },
        {
          key: 'pe_previousTreatment_zoloft',
          value: 'Zoloft (Sertraline)'
        },
        {
          key: 'pe_previousTreatment_anafranil',
          value: 'Anafranil (Clomipramine)'
        },
        {
          key: 'pe_previousTreatment_viagra',
          value: 'Viagra (Sildenafil)'
        },
        {
          key: 'pe_previousTreatment_cialis',
          value: 'Cialis (Tadalafil)'
        },
        {
          key: 'pe_previousTreatment_levitra',
          value: 'Levitra (Vardenafil)'
        },
        {
          key: 'pe_previousTreatment_implants',
          value: 'Penile implants'
        },
        {
          key: 'pe_previousTreatment_other',
          value: 'Other'
        },
        {
          key: 'pe_previousTreatment_none',
          value: 'None of these apply',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your other treatment',
    field: 'pe_previousTreatment_other_details',
    type: 'info',
    answer: {
      name: 'pe_previousTreatment_other_details',
      type: 'text',
      placeholder: 'Other treatment details'
    }
  }, // Continuing from previous models...
  {
    label:
      'Do you have an issue achieving or maintaining a rigid erection before ejaculation?',
    field: 'pe_erectionIssue',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_erectionIssue_never',
          value: 'I never have an issue'
        },
        {
          key: 'pe_erectionIssue_sometimes',
          value: 'I sometimes have an issue'
        },
        {
          key: 'pe_erectionIssue_often',
          value: 'I often or always have an issue'
        }
      ]
    }
  },
  {
    label:
      'Have you had a physical exam with a healthcare provider in the past 3 years?',
    field: 'pe_physicalExam',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_physicalExam_normal',
          value: 'Yes, it was normal'
        },
        {
          key: 'pe_physicalExam_issues',
          value: 'Yes, but there were issues'
        },
        {
          key: 'pe_physicalExam_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the issues from your physical exam',
    field: 'pe_physicalExam_issues_details',
    type: 'info',
    answer: {
      name: 'pe_physicalExam_issues_details',
      type: 'text',
      placeholder: 'Physical exam issues'
    }
  },
  {
    label: 'Was your blood pressure taken in the past year?',
    field: 'pe_bloodPressure',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_bloodPressure_yes',
          value: 'Yes'
        },
        {
          key: 'pe_bloodPressure_no',
          value: 'No, I will get a new blood pressure measurement'
        }
      ]
    }
  },
  {
    label: 'What was the value? (Example: 115/72)',
    field: 'pe_bloodPressure_value',
    type: 'info',
    answer: {
      name: 'pe_bloodPressure_value',
      type: 'text',
      placeholder: 'Blood pressure value'
    }
  },
  {
    label: 'Do you experience any of the following cardiovascular symptoms?',
    field: 'pe_cardiovascularSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_cardiovascularSymptoms_chestPainStairs',
          value:
            'Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks'
        },
        {
          key: 'pe_cardiovascularSymptoms_chestPainSex',
          value: 'Chest pain or shortness of breath with sexual activity'
        },
        {
          key: 'pe_cardiovascularSymptoms_fainting',
          value: 'Unexplained fainting or dizziness'
        },
        {
          key: 'pe_cardiovascularSymptoms_legCramps',
          value: 'Prolonged cramping of the legs with exercise'
        },
        {
          key: 'pe_cardiovascularSymptoms_heartbeats',
          value: 'Abnormal heart beats or rhythms'
        },
        {
          key: 'pe_cardiovascularSymptoms_none',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Please tell us more about your symptoms and whether this has been evaluated by your doctor',
    field: 'pe_cardiovascularSymptoms_details',
    type: 'info',
    answer: {
      name: 'pe_cardiovascularSymptoms_details',
      type: 'text',
      placeholder: 'Cardiovascular symptoms details'
    }
  }, // Continuing physical/anatomical questions
  {
    label:
      "Do you have a marked curve or bend in the penis that interferes with sex, or Peyronie's Disease?",
    field: 'pe_peyronies',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_peyronies_yes',
          value: 'Yes'
        },
        {
          key: 'pe_peyronies_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you had active bending of your penis within the last 12 months?',
    field: 'pe_activeBending',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_activeBending_yes',
          value: 'Yes'
        },
        {
          key: 'pe_activeBending_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you experience pain with erections or with ejaculation?',
    field: 'pe_erectionPain',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_erectionPain_yes',
          value: 'Yes'
        },
        {
          key: 'pe_erectionPain_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you have a foreskin that is too tight?',
    field: 'pe_tightForeskin',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_tightForeskin_yes',
          value: 'Yes'
        },
        {
          key: 'pe_tightForeskin_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you have any of the following conditions?',
    field: 'pe_cardiacConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_cardiacConditions_heartFailure',
          value:
            'A prior heart attack, heart failure, or narrowing of the arteries'
        },
        {
          key: 'pe_cardiacConditions_clotting',
          value: 'Any clotting or bleeding disorder'
        },
        {
          key: 'pe_cardiacConditions_stroke',
          value:
            'Stroke or severe insufficiency of the autonomic nervous system'
        },
        {
          key: 'pe_cardiacConditions_qtProlongation',
          value: 'Any history of QT prolongation in you, or even your family'
        },
        {
          key: 'pe_cardiacConditions_arrhythmia',
          value: 'Heart arrhythmia (abnormal beating of the heart)'
        },
        {
          key: 'pe_cardiacConditions_heartAbnormalities',
          value:
            'Any acquired, congenital, or developmental abnormalities of the heart, including heart murmurs'
        },
        {
          key: 'pe_cardiacConditions_retinitis',
          value: 'Retinitis pigmentosa or anterior ischemic optic neuropathy'
        },
        {
          key: 'pe_cardiacConditions_stenosis',
          value: 'Idiopathic hypertrophic subaortic stenosis'
        },
        {
          key: 'pe_cardiacConditions_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label: 'Do you have any of these conditions?',
    field: 'pe_physicalConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_physicalConditions_peyronies',
          value:
            "A marked curve or bend in the penis that interferes with sex, or Peyronie's disease"
        },
        {
          key: 'pe_physicalConditions_pain',
          value: 'Pain with erections or with ejaculation'
        },
        {
          key: 'pe_physicalConditions_tightForeskin',
          value: 'A foreskin that is too tight'
        },
        {
          key: 'pe_physicalConditions_fibrousTissue',
          value:
            'Fibrous tissue in the penis (lumps and bumps under the skin that feel hard)'
        },
        {
          key: 'pe_physicalConditions_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Do you currently have or have you ever had any of the following mental health conditions?',
    field: 'pe_mentalHealth',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_mentalHealth_depression',
          value: 'Depression'
        },
        {
          key: 'pe_mentalHealth_mania',
          value: 'Mania'
        },
        {
          key: 'pe_mentalHealth_anxiety',
          value: 'Anxiety'
        },
        {
          key: 'pe_mentalHealth_bipolar',
          value: 'Bipolar disorder'
        },
        {
          key: 'pe_mentalHealth_schizophrenia',
          value: 'Schizophrenia'
        },
        {
          key: 'pe_mentalHealth_borderline',
          value: 'Borderline personality disorder'
        },
        {
          key: 'pe_mentalHealth_suicidal',
          value: 'Suicidal thoughts or plans to hurt yourself'
        },
        {
          key: 'pe_mentalHealth_other',
          value: 'Other'
        },
        {
          key: 'pe_mentalHealth_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your other diagnosis',
    field: 'pe_mentalHealth_other_details',
    type: 'info',
    answer: {
      name: 'pe_mentalHealth_other_details',
      type: 'text',
      placeholder: 'Other mental health diagnosis details'
    }
  }, // Continuing with mental health and medical conditions
  {
    label:
      'Have you experienced thoughts of hurting yourself or others within the last 12 months?',
    field: 'pe_suicidalThoughts',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_suicidalThoughts_yes',
          value: 'Yes'
        },
        {
          key: 'pe_suicidalThoughts_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Over the last two weeks, how often have you had little interest or pleasure in doing things?',
    field: 'pe_phq9Interest',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_phq9Interest_notAtAll',
          value: 'Not at all'
        },
        {
          key: 'pe_phq9Interest_severalDays',
          value: 'Several days'
        },
        {
          key: 'pe_phq9Interest_moreThanHalf',
          value: 'More than half the days'
        },
        {
          key: 'pe_phq9Interest_nearlyEvery',
          value: 'Nearly every day'
        }
      ]
    }
  },
  {
    label:
      'Over the last two weeks, how often have you felt down, depressed, or hopeless?',
    field: 'pe_phq9Hopeless',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_phq9Hopeless_notAtAll',
          value: 'Not at all'
        },
        {
          key: 'pe_phq9Hopeless_severalDays',
          value: 'Several days'
        },
        {
          key: 'pe_phq9Hopeless_moreThanHalf',
          value: 'More than half the days'
        },
        {
          key: 'pe_phq9Hopeless_nearlyEvery',
          value: 'Nearly every day'
        }
      ]
    }
  },
  {
    label:
      'Do you have or have you previously been diagnosed with any of the following?',
    field: 'pe_medicalConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_medicalConditions_prostateCancer',
          value: 'Prostate cancer'
        },
        {
          key: 'pe_medicalConditions_bph',
          value: 'Enlarged prostate (BPH)'
        },
        {
          key: 'pe_medicalConditions_bloodDisorders',
          value: 'Sickle cell anemia, myeloma, or leukemia'
        },
        {
          key: 'pe_medicalConditions_kidney',
          value: 'Kidney transplant or any condition affecting the kidney'
        },
        {
          key: 'pe_medicalConditions_pah',
          value: 'Pulmonary artery hypertension (PAH)'
        },
        {
          key: 'pe_medicalConditions_liver',
          value: 'Liver disease'
        },
        {
          key: 'pe_medicalConditions_ms',
          value: 'Multiple Sclerosis (MS) or similar disease'
        },
        {
          key: 'pe_medicalConditions_spinal',
          value: 'Spinal injuries and/or paralysis'
        },
        {
          key: 'pe_medicalConditions_neurological',
          value: 'Neurological diseases'
        },
        {
          key: 'pe_medicalConditions_ulcers',
          value: 'Stomach, intestinal, or bowel ulcers'
        },
        {
          key: 'pe_medicalConditions_arrhythmias',
          value: 'Heart arrhythmias (abnormal beating of the heart)'
        },
        {
          key: 'pe_medicalConditions_glaucoma',
          value: 'Narrow Angle Glaucoma'
        },
        {
          key: 'pe_medicalConditions_visionLoss',
          value: 'Acute vision loss at any point'
        },
        {
          key: 'pe_medicalConditions_hyponatremia',
          value: 'Hyponatremia (low blood sodium levels)'
        },
        {
          key: 'pe_medicalConditions_noSex',
          value:
            'Advised not to have sex for health reasons or any other reason'
        },
        {
          key: 'pe_medicalConditions_heartAbnormalities',
          value:
            'Any acquired, congenital, or developmental abnormalities of the heart'
        },
        {
          key: 'pe_medicalConditions_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label: 'Tell us more about your medical condition.',
    field: 'pe_medicalConditions_details',
    type: 'info',
    answer: {
      name: 'pe_medicalConditions_details',
      type: 'text',
      placeholder: 'Medical condition details'
    }
  }, // Continuing with medications and final sections
  {
    label:
      'Are you currently taking any of the following medications? (Select all that apply)',
    field: 'pe_currentMedications',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_currentMedications_antidepressants',
          value:
            'Depression or anxiety medication such as (SSRIs, SNRI, MAO inhibitors, tricyclics)'
        },
        {
          key: 'pe_currentMedications_alphablockers',
          value:
            'Alpha blockers (e.g., Coreg (carvedilol), Flomax (tamsulosin))'
        },
        {
          key: 'pe_currentMedications_nitro',
          value: 'Nitroglycerin spray, ointment, patches or tablets'
        },
        {
          key: 'pe_currentMedications_isosorbide',
          value:
            'Isosorbide mononitrate, or isosorbide dinitrate (Isordil, Dilatrate, Sorbitrate, Imdur, Ismo, Monoket) or other medicines containing nitrates'
        },
        {
          key: 'pe_currentMedications_alphablockers2',
          value:
            'Alpha blocker medications: doxazosin (Cardura), prazosin (Minipress), terazosin (Hytrin)'
        },
        {
          key: 'pe_currentMedications_riociguat',
          value: 'Riociguat (Adempas)'
        },
        {
          key: 'pe_currentMedications_antiretrovirals',
          value: 'Antiretrovirals for treatment of AIDS/HIV'
        },
        {
          key: 'pe_currentMedications_fentanyl',
          value: 'Fentanyl'
        },
        {
          key: 'pe_currentMedications_lithium',
          value: 'Lithium'
        },
        {
          key: 'pe_currentMedications_tramadol',
          value: 'Tramadol'
        },
        {
          key: 'pe_currentMedications_stjohnswort',
          value: "St. John's Wort"
        },
        {
          key: 'pe_currentMedications_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Are you currently using any of the following recreational drugs? (Select all that apply)',
    field: 'pe_recreationalDrugs',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'pe_recreationalDrugs_poppers',
          value: 'Poppers or Rush'
        },
        {
          key: 'pe_recreationalDrugs_amylNitrate',
          value: 'Amyl nitrate or butyl nitrate'
        },
        {
          key: 'pe_recreationalDrugs_cocaine',
          value: 'Cocaine'
        },
        {
          key: 'pe_recreationalDrugs_mdma',
          value: 'Molly (MDMA, ecstasy)'
        },
        {
          key: 'pe_recreationalDrugs_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'pe_otherInformation',
    type: 'info',
    answer: {
      name: 'pe_otherInformation',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (Truthfulness)',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

Consent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    field: 'pe_truthConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_truthConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          key: 'pe_truthConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  },
  {
    label: 'Consent (Premature Ejaculation)',
    educationalSlide: `This consent form provides information about the use of Phosphodiesterase-5 inhibitors (PDE5i), Selective Serotonin Reuptake Inhibitors (SSRIs), or Selective Serotonin and Norepinephrine Reuptake Inhibitors (SNRI) as a treatment for premature ejaculation (PE). Please read the information carefully.

Purpose of Treatment

PDE5 inhibitors (e.g., Sildenafil, Tadalafil) and SSRIs and SNRIs (e.g., Sertraline, Fluoxetine) are medications that may help delay ejaculation and improve sexual satisfaction. These medications may be prescribed alone or in combination with other treatments or behavioral therapies. It is important to note that the use of PDE5 inhibitors and SSRI/SNRIs for the treatment of premature ejaculation is considered an off-label use.

What Is Off-Label Use?

Off-label use means that the medication is being prescribed for a condition or purpose that is not specifically approved by the Food and Drug Administration (FDA). This is a common practice in medical care when evidence supports the effectiveness of a treatment for an unapproved use.

Potential Benefits
- Increased control over ejaculation timing
- Improved sexual performance and satisfaction
- Reduced stress and anxiety related to premature ejaculation

Potential Risks and Side Effects

PDE5 Inhibitors
Common side effects include headache, flushing, nasal congestion, dizziness, back pain, or upset stomach. Rare but serious side effects include vision or hearing loss, prolonged erections (priapism), or cardiovascular complications.

SSRIs
Common side effects include nausea, fatigue, dry mouth, diarrhea, or decreased libido. Rare but serious side effects include serotonin syndrome (a potentially life-threatening condition), changes in mood or behavior, or increased risk of bleeding.

Precautions

PDE5 inhibitors are not recommended for patients taking nitrates, alpha-blockers, or certain blood pressure medications due to the risk of severe hypotension. SSRIs may interact with other medications, including other antidepressants, blood thinners, or certain pain relievers. Inform your healthcare provider about all medications, supplements, and medical conditions before starting treatment.

Alternative Treatments
- Behavioral therapies (e.g., start-stop technique, pelvic floor exercises)
- Topical anesthetic sprays or creams
- Counseling or psychotherapy
- Condom use

Patient Responsibilities
- Follow the prescribed dosage and instructions
- Notify your healthcare provider immediately if you experience any severe side effects or adverse reactions
- Do not use these medications in combination with other treatments or substances unless approved by your provider`,
    field: 'pe_treatmentConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'pe_treatmentConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and I DO NOT wish to proceed'
        },
        {
          key: 'pe_treatmentConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the information and I wish to proceed'
        }
      ]
    }
  }
];

export default questionsModels;
